import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Image } from "capitalrx-components-2.0/lib/general";
import Access from "@/static/images/image-pink-bubble.jpg";
import Find from "@/static/images/image-green-bubble.jpg";
import Save from "@/static/images/image-blue-bubble.jpg";

import styles from "./WithTheApp.module.scss";

const WithTheApp = (): JSX.Element => {
  const { columns412 } = useResponsive({
    columns412: {
      desktop: 4,
      tablet: 4,
      mobile: 12,
    },
  });

  return (
    <section className={styles.WithAppWrapper} data-testid="with-app-section">
      <div className={styles.WithApp}>
        <Paragraph className={styles.sectionTitle} textAlign="center" testId="with-app-section-title">
          Saving on your medications has never been more simple
        </Paragraph>
        <Grid className={styles.WithAppSteps}>
          <Grid.Span columns={columns412}>
            <div className={styles.WithAppStepsOne}>
              <Image src={Access} alt="Access your card" testId="access-your-card-image" />

              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-1">
                1.
              </Paragraph>
              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-1-heading">
                Find the best price
              </Paragraph>
              <Paragraph className={styles.paragraph} textAlign="center" testId="with-app-point-1-text">
                at a pharmacy near you.
              </Paragraph>
            </div>
          </Grid.Span>
          <Grid.Span columns={columns412}>
            <div className={styles.WithAppStepsTwo}>
              <Image src={Find} alt="Find the best price" testId="find-best-price-image" />

              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-2">
                2.
              </Paragraph>
              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-2-heading">
                Present your card
              </Paragraph>
              <Paragraph className={styles.paragraph} textAlign="center" testId="with-app-point-2-text">
                at the pharmacy.
              </Paragraph>
            </div>
          </Grid.Span>
          <Grid.Span columns={columns412}>
            <div className={styles.WithAppStepsThree}>
              <Image src={Save} alt="Start saving" testId="start-saving-image" />
              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-3">
                3.
              </Paragraph>
              <Paragraph className={styles.heading} textAlign="center" testId="with-app-point-3-heading">
                Start saving
              </Paragraph>
              <Paragraph className={styles.paragraph} textAlign="center" testId="with-app-point-3-text">
                on your prescriptions.
              </Paragraph>
            </div>
          </Grid.Span>
        </Grid>
      </div>
    </section>
  );
};

export default WithTheApp;
